import { render, staticRenderFns } from "./registrationConsultationChDetail.vue?vue&type=template&id=72d5e726&scoped=true"
import script from "./registrationConsultationChDetail.vue?vue&type=script&lang=js"
export * from "./registrationConsultationChDetail.vue?vue&type=script&lang=js"
import style0 from "./registrationConsultationChDetail.vue?vue&type=style&index=0&id=72d5e726&prod&lang=less"
import style1 from "./registrationConsultationChDetail.vue?vue&type=style&index=1&id=72d5e726&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5e726",
  null
  
)

export default component.exports